/* game-room-frontend/src/App.js */
// src/App.jsx
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import Statistics from "./pages/Statistics";
import DuelArena from "./pages/DuelArena";
import { AuthProvider } from "./context/AuthContext";
import { SelectionProvider } from "./context/SelectionContext";
import PrivateRoute from "./routes/PrivateRoute";
import AnimatedBackground from "./pages/AnimatedBackground";
import Caisse from "./pages/Caisse";

const LOGIN_BACKGROUND_IMAGE = "url('/images/login-bg.jpg')";

function App() {
  useEffect(() => {
    document.documentElement.style.setProperty("--game-room-login-bg", LOGIN_BACKGROUND_IMAGE);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <SelectionProvider>
          <AnimatedBackground />
          <Routes>
            {/* Pages publiques */}
            <Route path="/" element={<DuelArena isHomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/duels" element={<DuelArena />} />
            <Route path="/duels/:duelId" element={<DuelArena />} />
            <Route path="/duels/:duelId/tv" element={<DuelArena tvMode />} />

            {/* Page existante conservée telle quelle */}
            <Route path="/caisse" element={<Caisse />} />

            {/* Routes protégées */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminPanel />
                </PrivateRoute>
              }
            />

            <Route
              path="/stats"
              element={
                <PrivateRoute>
                  <Statistics />
                </PrivateRoute>
              }
            />
          </Routes>
        </SelectionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
